"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestGoogleBookingPublicationSyncSchema = exports.googleBookingPublicationHealthSchema = exports.googleBookingPublicationAttemptSchema = exports.googleBookingServiceEligibilitySchema = exports.googleBookingLocationEligibilitySchema = exports.googleBookingValidationIssueSchema = exports.googleBookingValidationCodeSchema = exports.googleBookingValidationScopeSchema = exports.googleBookingValidationSeveritySchema = exports.googleBookingPublicationAttemptStatusSchema = exports.googleBookingPublicationTriggerSchema = exports.googleBookingProviderAvailabilitySchema = exports.googleBookingPublicationEnvironmentSchema = exports.googleBookingPublicationStatusSchema = void 0;
const zod_1 = require("zod");
exports.googleBookingPublicationStatusSchema = zod_1.z.enum([
    "NOT_REQUESTED",
    "BLOCKED",
    "PENDING",
    "PUBLISHED",
    "REJECTED",
    "ERROR",
]);
exports.googleBookingPublicationEnvironmentSchema = zod_1.z.enum([
    "SANDBOX",
    "PRODUCTION",
]);
exports.googleBookingProviderAvailabilitySchema = zod_1.z.enum([
    "SANDBOX_READY",
    "READY",
    "LIVE_ACCESS_REQUIRED",
]);
exports.googleBookingPublicationTriggerSchema = zod_1.z.enum([
    "MANUAL",
    "CANONICAL_CHANGE",
    "SCHEDULED",
]);
exports.googleBookingPublicationAttemptStatusSchema = zod_1.z.enum([
    "PENDING",
    "PROCESSING",
    "PUBLISHED",
    "REJECTED",
    "RETRYING",
    "ERROR",
]);
exports.googleBookingValidationSeveritySchema = zod_1.z.enum([
    "ERROR",
    "WARNING",
]);
exports.googleBookingValidationScopeSchema = zod_1.z.enum([
    "LOCATION",
    "SERVICE",
    "AVAILABILITY",
    "BOOKING_CONFIGURATION",
    "PROVIDER",
]);
exports.googleBookingValidationCodeSchema = zod_1.z.enum([
    "BOOKING_DISABLED",
    "PUBLISHED_CONFIGURATION_REQUIRED",
    "BOOKING_URL_REQUIRED",
    "LOCATION_REQUIRED",
    "LOCATION_INACTIVE",
    "LOCATION_ADDRESS_INCOMPLETE",
    "LOCATION_COUNTRY_UNSUPPORTED",
    "BUSINESS_PHONE_REQUIRED",
    "GOOGLE_PROFILE_MATCH_RECOMMENDED",
    "SERVICE_REQUIRED",
    "SERVICE_INACTIVE",
    "SERVICE_DURATION_REQUIRED",
    "SERVICE_DESCRIPTION_RECOMMENDED",
    "ONLINE_BOOKING_HOURS_REQUIRED",
    "AVAILABILITY_CAPABILITY_REQUIRED",
    "LIVE_PROVIDER_ACCESS_REQUIRED",
]);
exports.googleBookingValidationIssueSchema = zod_1.z.object({
    code: exports.googleBookingValidationCodeSchema,
    severity: exports.googleBookingValidationSeveritySchema,
    scope: exports.googleBookingValidationScopeSchema,
    entityId: zod_1.z.string().uuid().nullable(),
    path: zod_1.z.string().min(1).max(200),
    message: zod_1.z.string().min(1).max(500),
    action: zod_1.z.string().min(1).max(500),
});
exports.googleBookingLocationEligibilitySchema = zod_1.z.object({
    locationId: zod_1.z.string().uuid().nullable(),
    locationName: zod_1.z.string().min(1).max(120).nullable(),
    eligible: zod_1.z.boolean(),
    issues: zod_1.z.array(exports.googleBookingValidationIssueSchema).max(50),
});
exports.googleBookingServiceEligibilitySchema = zod_1.z.object({
    serviceId: zod_1.z.string().uuid(),
    serviceName: zod_1.z.string().min(1).max(160),
    eligible: zod_1.z.boolean(),
    issues: zod_1.z.array(exports.googleBookingValidationIssueSchema).max(20),
});
exports.googleBookingPublicationAttemptSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    status: exports.googleBookingPublicationAttemptStatusSchema,
    trigger: exports.googleBookingPublicationTriggerSchema,
    environment: exports.googleBookingPublicationEnvironmentSchema,
    attemptNumber: zod_1.z.number().int().positive(),
    retryable: zod_1.z.boolean().nullable(),
    requestedAt: zod_1.z.string().datetime(),
    startedAt: zod_1.z.string().datetime().nullable(),
    completedAt: zod_1.z.string().datetime().nullable(),
    nextRetryAt: zod_1.z.string().datetime().nullable(),
    providerReceiptId: zod_1.z.string().max(240).nullable(),
    errorCode: zod_1.z.string().max(120).nullable(),
    errorMessage: zod_1.z.string().max(500).nullable(),
});
exports.googleBookingPublicationHealthSchema = zod_1.z
    .object({
    status: exports.googleBookingPublicationStatusSchema,
    environment: exports.googleBookingPublicationEnvironmentSchema,
    providerAvailability: exports.googleBookingProviderAvailabilitySchema,
    providerConfirmed: zod_1.z.boolean(),
    pendingChanges: zod_1.z.boolean(),
    bookingUrl: zod_1.z.string().url().nullable(),
    publishedConfigurationVersionId: zod_1.z.string().uuid().nullable(),
    location: exports.googleBookingLocationEligibilitySchema,
    services: zod_1.z.array(exports.googleBookingServiceEligibilitySchema).max(100),
    eligibility: zod_1.z.object({
        eligible: zod_1.z.boolean(),
        issues: zod_1.z.array(exports.googleBookingValidationIssueSchema).max(250),
    }),
    lastAttemptAt: zod_1.z.string().datetime().nullable(),
    lastSuccessfulSyncAt: zod_1.z.string().datetime().nullable(),
    lastProviderConfirmationAt: zod_1.z.string().datetime().nullable(),
    nextScheduledSyncAt: zod_1.z.string().datetime().nullable(),
    nextRetryAt: zod_1.z.string().datetime().nullable(),
    lastError: zod_1.z
        .object({
        code: zod_1.z.string().max(120),
        message: zod_1.z.string().max(500),
        retryable: zod_1.z.boolean(),
    })
        .nullable(),
    recentAttempts: zod_1.z.array(exports.googleBookingPublicationAttemptSchema).max(20),
    canManage: zod_1.z.boolean(),
})
    .superRefine((value, context) => {
    if (value.status === "PUBLISHED" && !value.providerConfirmed) {
        context.addIssue({
            code: "custom",
            path: ["providerConfirmed"],
            message: "Published status requires provider confirmation.",
        });
    }
    if (value.providerConfirmed && value.status !== "PUBLISHED") {
        context.addIssue({
            code: "custom",
            path: ["providerConfirmed"],
            message: "Provider confirmation is valid only for published status.",
        });
    }
});
exports.requestGoogleBookingPublicationSyncSchema = zod_1.z.object({
    idempotencyKey: zod_1.z.string().uuid(),
});
//# sourceMappingURL=google-booking-publication.js.map